import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import { FilePickerViewType } from 'owa-filepicker';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import {
    ATTACHMENTS_FILE_PICKER_VIEW_TYPE_LIST as LIST,
    ATTACHMENTS_FILE_PICKER_VIEW_TYPE_TILE as TILE,
} from '../../../utils/constants';

export default function getUserPreferredViewType(
    configuration: OwaUserConfiguration
): FilePickerViewType {
    const viewType = configuration.ViewStateConfiguration.AttachmentsFilePickerViewTypeForMouse;

    switch (viewType) {
        case LIST:
            return FilePickerViewType.List;
        case TILE:
            return FilePickerViewType.Tile;
        default:
            // If the view type is not set then for consumer we default to Tile view
            // and for enterprise users we default to list view
            return isConsumer() ? FilePickerViewType.Tile : FilePickerViewType.List;
    }
}
